import { Component, Input } from '@angular/core';

@Component({
	selector: '[app-loading]',
	template: `
		<ng-content *ngIf="!enabled"></ng-content>
		
		<div *ngIf="enabled" 
			[style.height]="height" 
			class="ui basic segment" 
			style="width: 100%">
			<div class="ui active inverted dimmer">
				<div class="ui {{size}} text blue slow double loader"
					style="font-style: italic;">
					{{text}}
				</div>
			</div>
		</div>`,
	standalone: false
})
export class LoadingComponent {
	@Input() size = 'medium';
	@Input() text = 'Loading';
	@Input() height = '250px';
	@Input() enabled = true;
}